module.exports = __webpack_public_path__ + "img/bg-vip.4c482429.png";